module.exports = __webpack_public_path__ + "img/default-product_flat.625d1aff.jpg";